import React from "react";
import ReactDOM from "react-dom/client";
import store from "./store";
// import "./App.scss";
import { Provider } from "react-redux";
import Router from "./router";
import { RouterProvider } from "react-router-dom";

ReactDOM.createRoot(
  document.getElementById("keepsafe-rapidstor-frontend") as HTMLElement
).render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={Router} />
    </Provider>
  </React.StrictMode>
);
